<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn color="success" class="button-shadow mr-2" @click="isFindReport=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" to="/expensereport/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
              <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="csv"
                :name="getFileName()"
              >
              <v-btn 
                v-show="transactions.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" sm="12" md="12" lg="12" >
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px; vertical-align: top;"><img v-if="logo!=null" :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table v-if="data!=null" style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Start Date</span></td>
                            <td v-if="data!=null" style="text-align: right"><span style="font-size: 11pt;">{{ new Date(data.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">End Date</span></td>
                            <td v-if="data!=null" style="text-align: right"><span style="font-size: 11pt;">{{ new Date(data.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
                          </tr>
                          <tr v-if="data.locationid!=null">
                            <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ locations.length>0 ? locations.find(i=>i._id == data.locationid)['locationname'] : ''  }}</span></td>
                          </tr>
                         </table> 
                      </td>
                    </tr>
                  </table>
                  <p style="margin-top: 0; margin-bottom: 10px">&nbsp;</p>
                  <table style="width: 100%; padding-bottom: 10px;">
                    <tr>
                      <td>
                        <div align="center" style="padding: 0; line-height: 0;"><h3><b>{{ this.reporttitle }}</b></h3></div>
                      </td>
                    </tr>
                    <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                  </table>
                </v-row>
                <table v-for="(accountid, index) in data_accounts" v-bind:key="index" style="width: 100%" cellpadding="0" cellspacing="0">
                  <tbody>
                    <tr>
                      <th :style="css['row-head']" colspan="4" width="10%">{{ accountid }}</th>
                    </tr>
                    <tr>
                      <th :style="css['row-bottom-left']" width="20%">Account</th>
                      <th :style="css['row-bottom-right']" width="10%">Amount</th>
                    </tr>
                  </tbody>
                  <tbody v-if="getAccountTransaction(accountid).length!=0">
                    <tr v-for="(trans) in getAccountTransaction(accountid)"  v-bind:key="trans._id">
                        <td :style="css['row-left']">{{ trans.accountname }}</td>
                        <td :style="css['row-right']">{{ (trans.itemamount).toFixed(1) }}</td>
                      </tr>
                      <tr>
                        <td :style="css['row-right-end']"></td>
                        <td :style="css['row-right-end']">{{ getAccountSum(accountid).toFixed(2) }}</td>
                      </tr>
                    <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                  </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div>
    <v-dialog
      v-model="isFindReport"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Report</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  :items="locations.filter(x=>x.locationstatus=='Active' || x.locationstatus=='New').map(x => {
                            return {text: x.locationname, value: x._id};
                          })"
                  v-model="find_query.locationid"
                  label="Location"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  :items="saleschannels.filter(x=>x.channelstatus=='Active' || x.channelstatus=='New').map(x => {
                            return {text: x.channelname, value: x._id};
                          })"
                  v-model="find_query.channelid"
                  label="Channel"
                  required
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_startdate"
                  v-model="menu_startdate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.startdate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.startdate"
                      label="Start Date"
                      v-bind="attrs"
                      v-bind:value="find_query.startdate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter start date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.startdate"
                    no-title
                    scrollable
                  >
                  <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_startdate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_startdate.save(find_query.startdate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="menu_enddate"
                  v-model="menu_enddate"
                  :close-on-content-click="false"
                  :return-value.sync="find_query.enddate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="find_query.enddate"
                      label="End Date"
                      v-bind="attrs"
                      v-bind:value="find_query.enddate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter end date">
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="find_query.enddate"
                    no-title
                    scrollable
                  >
                  <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_enddate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_enddate.save(find_query.enddate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isFindReport = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="resetReport"
          >
            Reset
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findReport"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo, formatStdDate } from '../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            logo: null,
            isFindReport: false,
            menu_startdate: null,
            menu_enddate: null,
            companycode: null,
            reportname: 'Expense_Report_Account',
            reporttitle: 'Expense Report By Account',
            reportdate: '',
            digits: null,
            find_query: {},
            data: {},
            transactions: [],
            css: {
              'row-top-right': 'padding: 2px; text-align: right; border-top: 2px; border-top-style: solid;',
              'row-top-left': 'padding: 2px; text-align: left; border-top: 2px; border-top-style: solid; font-weight: bold;',
              'row-head': 'padding-bottom: 5px; text-align: left; border-bottom: 1px; border-bottom-style: none; font-weight: bold; font-size: 14pt;',
              'row-bottom-head': 'padding: 5px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
              'row-bottom-right': 'padding: 2px; text-align: right; border-bottom: 1px; border-bottom-style: solid;',
              'row-bottom-left': 'padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
              'row-left': 'font-size: 10pt; text-align: left; padding: 5px; vertical-align: top; border-bottom: 1px; border-bottom-style: none;',
              'row-right': 'font-size: 10pt; text-align: right; padding: 5px;border-bottom: 1px; border-bottom-style: none;',
              'row-left-end': 'font-size: 11pt; text-align: left; padding-top: 10px; vertical-align: top; border-top: 2px; border-top-style: solid;',
              'row-right-end': 'font-size: 11pt; text-align: right; padding-top: 10px;border-top: 2px; border-top-style: solid;',
            },
            formatStdDate: formatStdDate,
          };
        },
        computed: {
          ...mapState('Location', ['locations']),
          ...mapState('SalesChannel', ['saleschannels']),
          data_accounts(){
            let filter = this.transactions;
            let object = Object.groupBy(filter, item => {
              return item.accountsubclass;
            });
            let result = Object.keys(object);
            return result;
          },

        },
        methods: {
          ...mapActions('ExpenseReport', ["findExpenseReportByAccountRequest", "getExpenseReportByAccountRequest"]),
          ...mapActions('Location', ["getLocationsRequest"]),
          ...mapActions('SalesChannel', ["getSalesChannelsRequest"]),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html>');
            mywindow.document.write('<head><title>'+ `${this.companycode} ${this.reportname} ${ this.reportdate }` + '</title></head>');
            mywindow.document.write('<body onclick="window.print();">');  
            mywindow.document.write(content);
            mywindow.document.write('</body>');
            mywindow.document.write('</html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          resetReport(){
            this.find_query = {};
          },
          async findReport(){
            this.data = await this.findExpenseReportByAccountRequest(this.find_query);
            this.transactions = Object.assign([], this.data.transactions);
            this.isFindReport = false;
            this.reportdate = `${formatStdDate(this.data.startdate)}_${formatStdDate(this.data.enddate)}`;
          },
          getFileName(){
            var name = `${this.companycode} ${this.reportname}` + ' ' + `${this.reportdate}` ;
            return name + '.csv';
          },
          getJson(){
            let jsons = [];
            for(var item of this.transactions){
              let json = {
                accountclass: item.accountsubclass,
                startdate: this.formatStdDate(item.startdate),
                enddate: this.formatStdDate(item.enddate),
                accountname: item.accountname,
                expense_amount: item.itemamount,
              }
              jsons.push(json);
            }
            return jsons;
          },
          getAccountTransaction(id){
            let filter = [];
            if(id==null || id=='null') filter = this.transactions.filter(i=>i.accountsubclass==null || i.accountsubclass=='null');
            else filter = this.transactions.filter(i=>i.accountsubclass==id);
            return filter;
          },
          getAccountSum(id){
            let filter = [];
            if(id==null || id=='null') filter = this.transactions.filter(i=>i.accountsubclass==null || i.accountsubclass=='null');
            else filter = this.transactions.filter(i=>i.accountsubclass==id);
            let result = filter.reduce((a, b) => a + parseFloat(b.itemamount), 0);
            return result;
          }
        },
        async created () {
          this.data = await this.getExpenseReportByAccountRequest();
          this.transactions = Object.assign([], this.data.transactions);
          var companyid = localStorage.getItem("companyid");
          this.companycode = localStorage.getItem("companycode");
          this.logo = getLogo(companyid);
          this.reportdate = `${formatStdDate(this.data.startdate)}_${formatStdDate(this.data.enddate)}`;
          
          if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
          if(this.locations.length==0) await this.getLocationsRequest();
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
